import { DownTimePage } from 'down-time-page/down-time-page';
import { FreightPageResolver } from 'freight';
import { LoginPage } from 'login/login-page';
import { ManageCustomerParametersResolver } from 'manage-customer-parameters';
import { ProductsRoutes } from 'products/products-routes';
import { PropsWithChildren } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTES } from 'routing';
import { AuthenticationRequired } from 'routing/authentication-required';
import { AuthLayout, PublicLayout } from 'shared/components';
import { UnauthorizedPage } from 'unauthorized/unauthorized-page';
import { UploadPDFPageResolver } from 'upload-pdf/upload-pdf-page-resolver';
import { UserMappingRoutes } from 'user-mapping/user-mapping-routes';

function PrivateRoutes() {
  return (
    <Private>
      <Switch>
        <Route path={ROUTES.products}>
          <ProductsRoutes />
        </Route>
        <Route path={ROUTES.userMapping}>
          <UserMappingRoutes />
        </Route>
        <Route path={ROUTES.uploadPDF}>
          <UploadPDFPageResolver />
        </Route>
        <Route path={ROUTES.manageCustomerParameters}>
          <ManageCustomerParametersResolver />
        </Route>
        <Route path={ROUTES.freight}>
          <FreightPageResolver />
        </Route>
        <Route path='*'>
          <Redirect to={ROUTES.login} />
        </Route>
      </Switch>
    </Private>
  );
}

export function AppRoutes() {
  return (
    <Switch>
      <Route path={ROUTES.login} exact>
        <Public>
          <LoginPage />
        </Public>
      </Route>
      <Route path={ROUTES.unauthorized} exact>
        <Public>
          <UnauthorizedPage />
        </Public>
      </Route>
      <Route path='*'>
        <DownTimePage>
          <PrivateRoutes />
        </DownTimePage>
      </Route>
    </Switch>
  );
}

function Public({ children }: PropsWithChildren<{}>) {
  return <PublicLayout>{children}</PublicLayout>;
}

function Private({ children }: PropsWithChildren<{}>) {
  return (
    <AuthenticationRequired>
      <AuthLayout>{children}</AuthLayout>
    </AuthenticationRequired>
  );
}
